module.exports = __webpack_public_path__ + "static/media/whatif.1dd1ec43.png";